import { connectRefinementList } from 'instantsearch.js/es/connectors'
import { groupBy, map, last } from 'underscore'
import getOffset from '../getOffset'

let initItems = []
let isInit = false

const renderRefinementList = (renderOptions, isFirstRender) => {
  const {
    items,
    refine,
    widgetParams,
  } = renderOptions

  if (isFirstRender) {
    const div = document.createElement('div')
    div.classList.add('ais-RefinementList')
    div.innerHTML = '<ul class="ais-RefinementList-list"></ul>'

    widgetParams.container.appendChild(div)
  }

  if (!isInit && items.length > 0) {
    isInit = true
    initItems = items
  }

  const newItems = map(groupBy(initItems.concat(items), 'value'), last)

  widgetParams.container.querySelector('ul').innerHTML = newItems
    .map(
      item => `
        <li class="ais-RefinementList-item">
          <label class="ais-RefinementList-label">
            <input type="checkbox" ${item.isRefined ? 'checked' : ''} class="ais-RefinementList-checkbox" value="${item.value}" />
            <span class="ais-RefinementList-labelText">${widgetParams.isNews ? config.trads[`news.type.${item.label}`] : item.label}</span>
          </label>
        </li>
      `,
    )
    .join('');

  [...widgetParams.container.querySelectorAll('input')].forEach(element => {
    element.addEventListener('change', event => {
      event.preventDefault()
      refine(event.currentTarget.value)

      if (window.innerWidth < 768 && document.querySelector('.filters__mobile-wrap.is-fixed')) {
        window.scrollTo({
          top: getOffset(document.querySelector('[js-algolia-list]')) - 88,
          left: 0,
          behavior: 'smooth',
        })
      }
    })
  })
}

const customRefinementList = connectRefinementList(renderRefinementList)

export default customRefinementList
